module.exports = __webpack_public_path__ + "img/Ethiopia.a2fe3910.svg";